import {getFunctions,httpsCallable} from 'firebase/functions';
import {app} from '../firebase';
export const newAdvanceOperation=()=>window.crypto?.randomUUID?.() || `op_${Date.now()}_${Math.random().toString(36).slice(2)}`;
export async function bookingAdvanceCall(action,data) {
 return (await httpsCallable(getFunctions(app,'asia-south1'),'bookingAdvances')({action,...data})).data;
}
